import { FieldError } from "@trueskin-web/components"
import { useTranslation } from "@trueskin-web/translations"

export const PaymentErrorMessage = ({ paymentError }) => {
  const { t } = useTranslation(null, {
    keyPrefix: "Payment.errors",
  })

  if (paymentError === undefined || paymentError === null) {
    return null
  }

  return (
    <FieldError
      data-testid="web-portal-payment-error-message"
      sx={{
        mt: 3,
        p: 0,
      }}
    >
      {t(paymentError, t("UNKNOWN_REFUSAL_REASON"))}
    </FieldError>
  )
}
